import React from 'react';
import PropTypes from 'prop-types';

import Header from '../Header';
import Footer from '../Footer';

import { GlobalStyle } from '../../themes';

export default function Layout({
  activeRoute,
  mapImageOnBackground,
  children,
}) {
  return (
    <div style={{minHeight: '100vh', display: 'flex', flexDirection: 'column'}}>
      <Header activeRoute={activeRoute} />
      {children}
      <Footer />
      <GlobalStyle showMapImage={mapImageOnBackground} />
    </div>
  );
}

Layout.defaultProps = {
  mapImageOnBackground: true,
};

Layout.propTypes = {
  activeRoute: PropTypes.string,
  mapImageOnBackground: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};
